import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

const cacheSelector = createSelector(
  (localState) => localState.cache || {},
  (cache) => cache
);
const rulesSelector = createSelector(
  (localState) => localState.rules || [],
  (rules) => rules
);
const themeSelector = createSelector(
  (localState) => localState.theme || {},
  (theme) => theme
);

const NAMESPACE = 'themeProvider';

/**
 * Update Theme Method.
 * @TODO - Validate Theme Fields Before Updating in the Store
 *
 */
const updateTheme = (theme) => {
  return (dispatch) => dispatch({type: 'UPDATE_THEME', theme});
};

const updateThemeProvider = (cache = {}, rules = []) => {
  return (dispatch) => {
    dispatch({type: 'UPDATE_THEME_PROVIDER', cache, rules});
  };
};

const controller = new Controller({
  namespace: NAMESPACE,

  reducers: ['UPDATE_THEME', 'UPDATE_THEME_PROVIDER'],

  mapStateToProps(state) {
    const localState = this.getLocalState(state);

    return {
      theme: themeSelector(localState),
      cache: cacheSelector(localState),
      rules: rulesSelector(localState),
    };
  },

  actionCreators: {
    updateTheme,
    updateThemeProvider,
  },
});

export default controller;
